<template>
  <!-- 订单详情商品底部按钮 -->
  <div
    :class="{ flex_space: item.afterInfo }"
    class="item_bottom_btn border_top1px"
  >
    <div
      v-if="item.afterInfo"
      class="font12 font_weight500 colof00 line_height_14 refund_det text_left"
    >
      {{ item.afterInfo }}
    </div>
    <div class="btn_flex">
      <div
        v-for="(item, index) in btnList"
        :key="index"
        :class="{ warn: item.isLightHeight, colof: item.isLightHeight }"
        class="look_log font12 font_weight400 colo087 line_height_30"
        @click="clickBtn(item.name)"
      >
        {{ item.name }}
      </div>
    </div>

    <!-- <div
      class="warn font12 font_weight400 colof line_height_32"
      @click="actionProduct"
    >
      提醒发货
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    btnList: {
      type: Array,
      default() {
        return [];
      }
    },
    packageIndex: {
      type: Number,
      default: 0
    },
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  computed: {
    getUserOrder() {
      return this.$store.getters.getUserOrder;
    }
  },
  methods: {
    // actionProduct() {
    //   this.$toast("已提醒发货");
    // },
    // lookLogist() {
    //   this.$emit("lookLogist");
    // },
    clickBtn(name) {
      this.$emit(
        "clickBtn",
        name,
        this.getUserOrder.orderSn,
        this.packageIndex,
        this.item.subOrderSn
      );
    }
  }
};
</script>

<style lang="less" scoped>
.flex_space {
  justify-content: space-between !important;
}
.item_bottom_btn {
  background: #fff;
  margin: 0 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 8px;
  .btn_flex {
    display: flex;
  }
  .look_log {
    box-shadow: 0px 10px 10px -6px #f2f0f0;
    border-radius: 2px;
    border: 1px solid #000;
    box-sizing: border-box;
    margin-right: 8px;
    padding: 0 18px;
  }
  .warn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
    margin-right: 8px;
    padding: 0 18px;
    border: 0;
  }
}
</style>
